export enum RecurrenceType {
  DoesNotRepeat = 0,
  EveryDay = 1,
  EveryWeek = 2,
  EveryMonth = 3,
  EveryYear = 4,
  Custom = 5,
}

export enum RecurrenceOption {
  RepeatDaily = 1,
  RepeatWeekly = 2,
  RepeatMonthly = 3,
  RepeatYearly = 4,
}

export enum RecurrenceSchedule {
  Days = 1,
  Weeks = 2,
  Months = 3,
  Years = 4,
}
